import {
  components as ReactSelectComponents,
  GroupBase,
  OptionProps,
} from 'react-select';
import React from 'react';
import KubitTooltip from '../KubitTooltip';
import { isNil } from 'lodash';
import { IReactSelectFieldValueOption } from './types';

const PfvOption = <
  Option extends IReactSelectFieldValueOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  children,
  ...singleValueProps
}: OptionProps<Option, IsMulti, Group>) => {
  let content;
  const option = singleValueProps.data;
  if (!isNil(option.tooltip)) {
    content = (
      <KubitTooltip
        content={option.tooltip}
        placement="left"
        noOpenDelay={true}
      >
        <div>{children}</div>
      </KubitTooltip>
    );
  } else {
    content = children;
  }
  return (
    <ReactSelectComponents.Option {...singleValueProps}>
      {content}
    </ReactSelectComponents.Option>
  );
};

export default PfvOption;
